// extracted by mini-css-extract-plugin
export default {"root":"ViewDetails_root__8NsMS"};